import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Announcement } from "src/app/models/announcement/announcement";
import { AnnouncementService } from "src/app/services/announcement.service";
import {
  getIconFromState,
  getIconFromStatus,
} from "src/app/shared/list-item.utils";
import { AnnouncementState } from "../../../../../models/announcement/announcement-enums";

@Component({
  standalone: false,
  selector: "dua-announcement-list-item",
  templateUrl: "./announcement-list-item.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./announcement-list-item.component.scss"],
})
export class AnnouncementListItemComponent implements OnInit {
  @Input() announcement!: Announcement;
  @Output() dragStarted = new EventEmitter<DragEvent>();
  @Output() dragOverItem = new EventEmitter<DragEvent>();
  @Output() dropped = new EventEmitter<DragEvent>();
  public tooltipText!: string;
  private dragged = false;

  constructor(private announcementService: AnnouncementService) {}

  ngOnInit() {
    this.setAnnouncementReplacementText();
  }

  onDragStart(event: DragEvent) {
    this.dragged = true;
    this.dragStarted.emit(event);
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.dragOverItem.emit(event);
  }

  onDrop(event: DragEvent) {
    this.dropped.emit(event);
  }

  onDragEnd() {
    setTimeout(() => {
      this.dragged = false;
    });
  }

  onClick(event: MouseEvent) {
    if (!this.dragged) {
      return;
    }
    this.dragged = false;
    event.preventDefault();
    event.stopPropagation();
  }

  public getClassNameFromState(): string {
    if (this.announcement.toBeDeleted) {
      this.announcement.state = AnnouncementState.Removed;
    }

    if (this.announcement.percentageReplacedByAnother > 0) {
      return "replaced";
    }

    return AnnouncementState[this.announcement.state]?.toLowerCase();
  }

  public getStateText(): string {
    switch (this.announcement.state) {
      case AnnouncementState.Changed:
        return "Ändrad.";
      case AnnouncementState.New:
        return "Ny.";
      case AnnouncementState.Removed:
        return "Struken.";
      default:
        return "";
    }
  }

  getIconFromStatus(): string {
    if (
      this.announcement.state === AnnouncementState.Unchanged &&
      this.announcement.percentageReplacedByAnother > 0
    ) {
      return "attention";
    }
    if (
      this.announcement.state === AnnouncementState.Unchanged ||
      (this.announcement.state === AnnouncementState.Removed &&
        this.announcement.status !== "Accepted" &&
        this.announcement.toBeDeleted)
    ) {
      return getIconFromStatus(
        this.announcement?.notified,
        this.announcement?.status
      );
    }
    return getIconFromState(this.announcement?.notified);
  }

  setAnnouncementReplacementText() {
    this.tooltipText = this.announcementService.getAnnouncementReplacementText(
      this.announcement
    );
  }
}
